/**
 * Copyright 2022 Design Barn Inc.
 */

import * as React from 'react';

export const TriangleDown: React.FC = (): JSX.Element => (
  <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.47828 1.11375L4.62826 3.80831L1.8435 1.04637L7.47828 1.11375Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
